import { Users2 } from 'lucide-react'
import { Badge } from '@/components/ui/badge'

export function AudienceTargetingBlock({
  primary,
  secondary,
  showHeader = true,
}: {
  primary?: string
  secondary?: string
  showHeader?: boolean
}) {
  if (!primary && !secondary) return null

  return (
    <div className="space-y-4">
      {showHeader && (
        <div className="flex items-center gap-2">
          <Users2 className="h-5 w-5 text-blue-600 dark:text-blue-400" />
          <h4 className="font-semibold text-foreground">Audience Targeting</h4>
        </div>
      )}

      <div className="space-y-3">
        {primary && (
          <div className="p-4 rounded-lg bg-muted/50 border">
            <div className="flex items-center gap-2 mb-2">
              <Badge variant="default" className="text-xs">Primary</Badge>
            </div>
            <p className="text-sm text-muted-foreground">{primary}</p>
          </div>
        )}
        {secondary && (
          <div className="p-4 rounded-lg bg-muted/30 border">
            <div className="flex items-center gap-2 mb-2">
              <Badge variant="outline" className="text-xs">Secondary</Badge>
            </div>
            <p className="text-sm text-muted-foreground">{secondary}</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default AudienceTargetingBlock


